import { render } from "./AppDialog.vue?vue&type=template&id=3669d862&ts=true"
import script from "./AppDialog.vue?vue&type=script&lang=ts"
export * from "./AppDialog.vue?vue&type=script&lang=ts"

import "./AppDialog.vue?vue&type=style&index=0&id=3669d862&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__